import { type AgencyId, type CompanyContactId, formatAddress } from "@inrev/common";
import {
	AdminPrincipalPreview,
	AdminSuretyAccountPreview,
} from "@portal/api/bond-request/admin/types";

export const getPrincipalPreviewsMapFromAccountPreviewsWithAgency = (
	accountPreviews: AdminSuretyAccountPreview[],
): Record<CompanyContactId, AdminPrincipalPreview> => {
	const principalPreviewsMap: Record<CompanyContactId, AdminPrincipalPreview> = {};
	accountPreviews.forEach((account) => {
		const searchValues: string[] = [
			...account.companies.flatMap((company) => [company.name, formatAddress(company.address)]),
			...account.individuals.map((individual) => individual.name),
		];
		if (account.displayName) searchValues.push(account.displayName);
		account.companies.forEach((company) => {
			principalPreviewsMap[company.id] = {
				...company,
				address: formatAddress(company.address),
				companyContactId: company.id,
				accountId: account.id,
				accountDisplayName: account.displayName,
				agencyId: account.agencyId,
				searchValues,
			};
		});
	});
	return principalPreviewsMap;
};

export const filterPrincipalPreviewsByAgency = (
	map: Record<CompanyContactId, AdminPrincipalPreview>,
	agencyId: AgencyId | undefined,
): Record<CompanyContactId, AdminPrincipalPreview> => {
	if (!agencyId) return map;
	return Object.fromEntries(
		Object.entries(map).filter(([_, preview]) => preview.agencyId === agencyId),
	) as Record<CompanyContactId, AdminPrincipalPreview>;
};
